// Mantine
import { Menu, ActionIcon, Modal, TextInput, Button } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

// Icon
import {
    IconDotsVertical,
    IconChecklist,
    IconPrinter,
} from '@tabler/icons-react'

// React
import { useState } from 'react'

// UI
import CarrierSelect from '../ui/CarrierSelect'

export default function FulfillmentOrderOptions({ shipment, sendOnly }) {
    // Mark as fulfilled
    const [markAsFulfilledOpened, markAsFulfilledHandlers] =
        useDisclosure(false)

    // Mark as manually fulfilled
    const [markAsManuallyFulfilledOpened, markAsManuallyFulfilledHandlers] =
        useDisclosure(false)

    const [carrier, setCarrier] = useState('DHLExpress')
    const [trackingCode, setTrackingCode] = useState('')

    const sendOnlyHandler = (withTrackingCode = false) => {
        if (withTrackingCode) {
            sendOnly({
                tracking_code: trackingCode,
            })
        } else {
            sendOnly()
        }
    }

    return (
        <>
            <Menu shadow="md" position="bottom">
                <Menu.Target>
                    <ActionIcon variant="default" size={36}>
                        <IconDotsVertical size={15} />
                    </ActionIcon>
                </Menu.Target>

                <Menu.Dropdown>
                    {shipment && (
                        <Menu.Item
                            onClick={markAsFulfilledHandlers.open}
                            leftSection={<IconChecklist size={18} />}
                        >
                            Expédier avec le bordereau du BO
                        </Menu.Item>
                    )}

                    <Menu.Item
                        onClick={markAsManuallyFulfilledHandlers.open}
                        leftSection={<IconChecklist size={18} />}
                    >
                        Expédier avec un bordereau externe
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>

            <Modal
                opened={markAsFulfilledOpened}
                onClose={markAsFulfilledHandlers.close}
                title="Marquer comme expedié avec le bordereau"
            >
                <div className="flex flex-col gap-3">
                    <span className="text-gray-500">
                        Marquer comme expédié sans procéder à l'impression du
                        bordereau.
                    </span>

                    <div className="flex flex-col">
                        <span className="text-sm font-medium">Suivi DHL</span>
                        <span>
                            {shipment?.tracking_code} - Généré par le BO
                        </span>
                    </div>

                    <Button
                        leftSection={<IconChecklist size={18} />}
                        onClick={sendOnlyHandler}
                    >
                        Marquer comme expedié
                    </Button>
                </div>
            </Modal>

            <Modal
                opened={markAsManuallyFulfilledOpened}
                onClose={markAsManuallyFulfilledHandlers.close}
                title="Expédier avec un bordereau externe"
            >
                <div className="flex flex-col gap-3">
                    <CarrierSelect value={carrier} onChange={setCarrier} />

                    <TextInput
                        label="Numéro de suivi"
                        value={trackingCode}
                        onChange={(event) =>
                            setTrackingCode(event.target.value)
                        }
                    />

                    <Button
                        leftSection={<IconChecklist size={18} />}
                        onClick={() => sendOnlyHandler(true)}
                    >
                        Marquer comme expedié
                    </Button>
                </div>
            </Modal>
        </>
    )
}
